import React from 'react';
import { Outlet } from 'react-router-dom';
import './SuperAdminLMSLayout.css';

const SuperAdminLMSLayout = ({ children }) => {
  console.log('SuperAdminLMSLayout rendering with children:', !!children);
  
  return (
    <div className="lms-layout">
      <main className="lms-main-content" tabIndex={-1}>
        {children || <Outlet />}
      </main>
    </div>
  );
};

export default SuperAdminLMSLayout;
